import styled from 'styled-components';
import { zIndex } from 'tokens';

export const PanelWrapper = styled.div`
	grid-area: left-panel;
	z-index: ${zIndex.panel};
	display: flex;
	flex-direction: column;
`;

export const ScrollingArea = styled.div`
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	scrollbar-width: thin;
	&::-webkit-scrollbar {
		width: 8px;
	}
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};
`;

interface SiteEntryProps {
	active: boolean;
	disabled: boolean;
}

export const SiteEntry = styled.div<SiteEntryProps>`
	align-self: flex-start;
	border: 1px solid ${({ theme }) => theme.gray[400]};
	width: calc(100% - 28px);
	border-radius: 12px;
	padding: 8px 12px;
	margin: 4px 0;
	background-color: transparent;
	&:hover {
		background-color: ${({ theme, active, disabled }) =>
			active && !disabled ? theme.gray[200] : 'transparent'};
	}
`;

export const SiteSpacer = styled.div`
	flex: 1;
`;

export const SiteIcon = styled.div`
	margin-top: 2px;
	margin-bottom: -2px;
`;

export const SiteLabel = styled.div`
	padding-top: 2px;
	font-size: 14px;
	color: ${({ theme }) => theme.gray[800]};
`;

export const SiteSubLabel = styled.div`
	padding-top: 4px;
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const SiteLabelHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const SiteLabelDetails = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const EditEntry = styled.div`
	// layout
	width: calc(100% - 68px);
	padding: 10px;
	padding-top: 8px;
	padding-bottom: 12px;
	padding-left: 14px;
	margin-left: 36px;
	align-self: flex-end;

	// style
	background-color: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[1000]};
	border-radius: 18px;
	border-bottom-right-radius: 0px;
`;

export const Entries = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 8px;
`;

export const SelectedElementsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	flex-wrap: wrap;
	padding-bottom: 4px;
	margin-left: -2px;
`;

export const SelectedElementEntry = styled.div`
	color: ${({ theme }) => theme.gray[600]};
	font-size: 13px;
	padding: 4px;
	padding-left: 6px;
	padding-right: 6px;
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.gray[400]};
`;

export const Prompt = styled.div`
	padding-top: 4px;
	font-size: 13px;
	line-height: 20px;
	user-select: text;
	cursor: text;
`;

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 20px;
	text-align: center;
	height: 100%;
`;

export const EmptyStateIcon = styled.div`
	margin-bottom: 16px;
	opacity: 0.6;
`;

export const EmptyStateText = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	margin-bottom: 8px;
`;

export const EmptyStateSubtext = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
	line-height: 20px;
	max-width: 280px;
`;
